"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TABLE = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _interfaces = require("../interfaces");
var _table = require("../styling/table.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TABLE = function TABLE(_ref) {
  var children = _ref.children,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? _interfaces.EUiContainers.TR : _ref$tag,
    styles = _ref.styles,
    className = _ref.className,
    testId = _ref.testId;
  var _useStyles = (0, _table.useStyles)(),
    root = _useStyles.root;
  var combineClasses = (0, _classnames["default"])(root, className);
  var tableLayout = /*#__PURE__*/_react["default"].createElement("table", {
    "data-testid": testId,
    className: combineClasses,
    style: styles
  }, /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "ContainerTable"
  }, children));
  var divLayout = /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId,
    className: "DivContainer"
  }, children);
  return tag === _interfaces.EUiContainers.DIV ? divLayout : tableLayout;
};
exports.TABLE = TABLE;
var _default = /*#__PURE__*/_react["default"].memo(TABLE);
exports["default"] = _default;